import { Controller } from "@hotwired/stimulus"

// Ordnerzugriff card of the role form (BAUTASK-241). Unticking an Ordnervorlage hides
// everything below it for the role, so its sub-templates are dimmed while it is unticked.
// Dimmed only, never disabled: a disabled checkbox is not posted, which would store every
// child as hidden and lose its own setting for when the parent is ticked again.
export default class extends Controller {
  static targets = ["node", "children"]

  connect() {
    this.nodeTargets.forEach((node) => this.refresh(node))
  }

  toggle(event) {
    this.refresh(event.target.closest("[data-folder-access-tree-target='node']"))
  }

  refresh(node) {
    const checkbox = node.querySelector(":scope > label input[type='checkbox']")
    const children = node.querySelector(":scope > [data-folder-access-tree-target='children']")
    if (!checkbox || !children) return

    children.classList.toggle("opacity-50", !checkbox.checked)
    children.classList.toggle("pointer-events-none", !checkbox.checked)
    children.setAttribute("aria-disabled", String(!checkbox.checked))
  }
}
